export const fileTitles = [{
    name: '1.jpg',
    alt: "sign"
  },
  {
    name: '2.jpg',
    alt: "more signage"
  },
  {
    name: '3.jpg',
    alt: "sharing wisdom"
  },
  {
    name: '4.jpg',
    alt: 'initiating'
  },
  {
    name: '5.jpg',
    alt: 'sharing ideas'
  },
  {
    name: '6.jpg',
    alt: 'Talking about nutrition'
  },
  {
    name: '7.jpg',
    alt: 'ASHAs havin fun'
  },
  {
    name: '8.jpg',
    alt: 'Light lecture'
  },
  {
    name: "9.jpg",
    alt: 'ASHAs listening'
  },
  {
    name: '10.jpg',
    alt: 'practicising more knowledge'
  },
  {
    name: "11.jpg",
    alt: 'ASHAs grasping knowledge about their issues'
  },
  {
    name: '12.jpg',
    alt: 'About health'
  },
  {
    name: '13.jpg',
    alt: 'More Lectures'
  },
  {
    name: '14.jpg',
    alt: 'Intense focus'
  },
  {
    name: '15.jpg',
    alt: 'Learning a lot'
  }
];



// WEBPACK FOOTER //
// ./src/components/Events/AshaTraining/Asha-data.js